import {ActivatedRoute, Routes} from '@angular/router';
import { HomeComponent } from './home.component';
import { AuthGuard } from '../guards/auth.guard';
import { ReportsComponent } from './reports/reports.component';
import { AdministrationComponent } from './administration/administration.component';
import { UsersComponent } from './administration/users/users.component';
import { UserComponent } from './administration/users/user/user.component';
import { ConfigsComponent } from './administration/configs/configs.component';
import { TemplatesComponent } from './administration/templates/templates.component';
import { UserEmailTemplatesEditComponent } from './administration/templates/user-email-templates/user-email-templates-edit/user-email-templates-edit.component';
import { InvoiceEmailTemplatesEditComponent } from './administration/templates/invoice-email-templates/invoice-email-templates-edit/invoice-email-templates-edit.component';
import { InvoicePdfTemplatesEditComponent } from './administration/templates/invoice-pdf-templates/invoice-pdf-templates-edit/invoice-pdf-templates-edit.component';
import { RoleGuard } from '../guards/role.guard';
import { CardsComponent } from './cards/cards.component';
import { CustomersOverviewComponent } from './customers-overview/customers-overview.component';

import { SendEmailComponent } from './send-email/sendemail.component';
import { NewEditSendMailComponent } from './send-email/new-edit-sendmail/new-edit-sendmail.component';

import { CustomerOverviewDetailComponent } from './customers-overview/customer-overview-detail/customer-overview-detail.component';
import { CustomersComponent } from './customers/customers.component';
import { CompaniesComponent } from './companies/companies.component';
import { CompanyEditComponent } from './companies/company-edit/company-edit.component';
import { CompanyViewComponent } from './companies/company-view/company-view.component';
import { ProductEditComponent } from './products/product-edit/product-edit.component';
import { ProductViewComponent } from './products/product-view/product-view.component';
import { ProductsComponent } from './products/products.component';
import { CardViewComponent } from './cards/card-view/card-view.component';
import { CardEditComponent } from './cards/card-edit/card-edit.component';
import { CustomerViewComponent } from './customers/customer-view/customer-view.component';
import { CustomerEditComponent } from './customers/customer-edit/customer-edit.component';
import { OrderImportsComponent } from './orders/order-imports/order-imports.component';
import { OrderImportViewComponent } from './orders/order-imports/order-import-view/order-import-view.component';
import { SepaImportComponent } from './sepas/sepa-imports/sepa-imports.component';
import { SepaImportViewComponent } from './sepas/sepa-imports/sepa-import-view/sepa-import-view.component';
import { InvoicesComponent } from './invoices/invoices.component';
import { InvoiceViewComponent } from './invoices/invoice-view/invoice-view.component';
import { InvoiceEditComponent } from './invoices/invoice-edit/invoice-edit.component';
import { SofortTransactionImportsComponent } from './soforts/sofort-transaction-imports/sofort-transaction-imports.component';
import { SofortTransactionImportViewComponent } from './soforts/sofort-transaction-imports/sofort-transaction-import-view/sofort-transaction-import-view.component';
import { SofortStatementImportViewComponent } from './soforts/sofort-statement-imports/sofort-statement-import-view/sofort-statement-import-view.component';
import { SofortStatementImportsComponent } from './soforts/sofort-statement-imports/sofort-statement-imports.component';
import { SofortsComponent } from './soforts/soforts.component';
import { OrdersComponent } from './orders/orders.component';
import { SepasComponent } from './sepas/sepas.component';
import { OrderViewComponent } from './orders/order-view/order-view.component';
import { OrderEditComponent } from './orders/order-edit/order-edit.component';
import { CardCreationImportsComponent } from './orders/card-creations/card-creation-imports.component';
import { CardCreationImportViewComponent } from './orders/card-creations/card-activation-import-view/card-creation-import-view.component';
import { CardActivationImportViewComponent } from './orders/card-activations/card-activation-import-view/card-activation-import-view.component';
import { CardActivationImportsComponent } from './orders/card-activations/card-activation-imports.component';
import { OrderEmailTemplatesEditComponent } from './administration/templates/order-email-templates/order-email-templates-edit/order-email-templates-edit.component';
import { CustomerEmailTemplatesEditComponent } from './administration/templates/customer-email-templates/customer-email-templates-edit/customer-email-templates-edit.component';
import { MyAccountComponent } from './my-account/my-account.component';
import { ChangePasswordComponent } from './my-account/change-password/change-password.component';
import { VoucherOrderComponent } from './vouchers/voucher-orders.component';
import { VoucherOrderViewComponent } from './vouchers/voucher-order-view/voucher-order-view.component';
import { VoucherOrderAddComponent } from './vouchers/voucher-order-add/voucher-order-add.component';
import { OtherTemplatesEditComponent } from './administration/templates/other-templates/other-templates-edit/other-templates-edit.component';
import { ReminderDistributionComponent } from './administration/reminders/reminder-distribution/reminder-distribution.component';
import { RemindersComponent } from './administration/reminders/reminders.component';
import { DebtorsComponent } from './administration/debtors/debtors.component';
import { DebtorDistributionComponent } from './administration/debtors/debtor-distribution/debtor-distribution.component';
import { FeesComponent } from './administration/fees/fees.component';
import { PaymentImportComponent } from './payment-import/payment-import.component';
import { PaymentImportViewComponent } from './payment-import/payment-import-view/payment-import-view.component';
import {TotalCardOrdersComponent} from './total-card-orders/total-card-orders.component';
import {TotalCardOrderViewComponent} from './total-card-orders/total-card-order-view/total-card-order-view.component';
import {IdvCustomersOverviewComponent} from './idv-customers-overview/idv-customers-overview.component';
import {IdvCustomerOverviewDetailComponent} from './idv-customers-overview/customer-overview-detail/idv-customer-overview-detail.component';
import {OrdersCancellationsInternComponent} from './orders-cancellations-intern/orders-cancellations-intern.component';
import {OrdersCancellationsInternDetailComponent} from './orders-cancellations-intern/orders-cancellations-intern-detail/orders-cancellations-intern-detail.component';
import {TotalCardEmailTemplatesEditComponent} from './administration/templates/total-card-email-templates/total-card-email-templates-edit/total-card-email-templates-edit.component';
import {CardRenewalComponent} from './cards/card-renewal/card-renewal.component';
import {CardRenewalViewComponent} from './cards/card-renewal/card-renewal-view/card-renewal-view.component';
import {AddressCustomersOverviewComponent} from './address-customers-overview/address-customers-overview.component';
import {AddressCustomerOverviewDetailComponent} from './address-customers-overview/address-overview-detail/address-customer-overview-detail.component';
import {OrderSmsTemplatesEditComponent} from './administration/templates/sms-order-templates/order-sms-templates-edit/order-sms-templates-edit.component';
import {ImportTotalTransactionsComponent} from './total-card-orders/import-transactions/import-total-transactions.component';
import {TotalStatsImportViewComponent} from './total-card-orders/import-transactions/total-stats-import-view/total-stats-import-view.component';
import {PaymentReportComponent} from './payment-report/payment-report.component';
import {RevolutComponent} from './sepas/revolut.component';
import {RevolutDetailsComponent} from './sepas/revolut-detail/revolut-details.component';
import {RiskComponent} from './risk/risk.component';
import {RiskCheckComponent} from './risk/risk-check/risk-check.component';
import {RiskCheckDetailComponent} from './risk/risk-check-detail/risk-check-detail.component';
import {LoadsComponent} from './loads/loads.component';
import {BtlComponent} from './btl/btl.component';
import {BtlViewComponent} from './btl/btl-view/btl-view.component';
import {BtlEditComponent} from './btl/btl-edit/btl-edit.component';
import {TransactionViewComponent} from './btl/transaction-view/transaction-view.component';
import {LastLoadFilesComponent} from './btl/last-load-files/last-load-files.component';
import {GpsLoadResponseUploadComponent} from './btl/gps-load-response-upload/gps-load-response-upload.component';
import {PepComponent} from './pep/pep.component';
import {GpsHistoryComponent} from './btl/gps-history/gps-history.component';
import {WalletViewComponent} from './partner-wallet/wallet-view/wallet-view.component';
import {WalletListComponent} from './partner-wallet/wallet-list/wallet-list.component';
import {LoadsApprovalComponent} from './partner-wallet/loads-approval/loads-approval.component';
import {LoadDetailComponent} from './partner-wallet/load-detail/load-detail.component';
import {LoadRefundsComponent} from './btl/load-refunds/load-refunds.component';
import {LoadRefundsViewComponent} from './btl/load-refunds/load-refunds-view/load-refunds-view.component';
import {LoadRefundsHistoryComponent} from './btl/load-refunds/load-refunds-history/load-refunds-history.component';
import {OrderExportAllComponent} from './orders/order-export-all/order-export-all.component';
import {
  ViewWalletTransactionComponent
} from './partner-wallet/view-wallet-transaction/view-wallet-transaction.component';
import {PendingInvitesComponent} from './partner-wallet/pending-invites/pending-invites.component';
import {PendingInviteDetailComponent} from './partner-wallet/pending-invite-detail/pending-invite-detail.component';
import {WalletUserViewComponent} from './partner-wallet/wallet-user-view/wallet-user-view.component';
import {SofBtlDetailComponent} from './sof/sof-btl-detail/sof-btl-detail.component';
import {SofGenericDetailComponent} from './sof/sof-generic-detail/sof-generic-detail.component';
import {CashbackGroupsComponent} from './administration/cashback-groups/cashback-groups.component';
import {
  CashbackGroupsEditComponent
} from './administration/cashback-groups/cashback-groups-edit/cashback-groups-edit.component';
import {
  CashbackGroupsDetailComponent
} from './administration/cashback-groups/cashback-groups-detail/cashback-groups-detail.component';
import {PartnerCounterComponent} from './partner-counter/partner-counter.component';
import {
  PartnerCounterCreateInvoiceComponent
} from './partner-counter/partner-counter-create-invoice/partner-counter-create-invoice.component';
import {PartnerCounterIndexComponent} from './partner-counter/partner-counter-index/partner-counter-index.component';
import {
  PartnerCounterInvoiceDetailComponent
} from './partner-counter/partner-counter-invoice-detail/partner-counter-invoice-detail.component';
import {NextAnnualFeesComponent} from './next-annual-fees/next-annual-fees.component';
import {NextCardExpiriesComponent} from './next-card-expiries/next-card-expiries.component';
import {LastCardActivitiesComponent} from './last-card-activities/last-card-activities.component';
import {BlockedCardsComponent} from './risk/blocked-cards/blocked-cards.component';
import {DormantCardsComponent} from './risk/dormant-cards/dormant-cards.component';
import {ActivateTotpComponent} from './my-account/activate-totp/activate-totp.component';
import {MustActivateMfaComponent} from './my-account/must-activate-mfa/must-activate-mfa.component';
import {CollectionSearchComponent} from './collection-search/collection-search.component';
import {CollectionSearchDetailComponent} from './collection-search-detail/collection-search-detail.component';
import {RedirectRoleDeciderComponent} from './redirect-role-decider/redirect-role-decider.component';
import {ReferralsComponent} from './referrals/referrals.component';
import {ReferralViewComponent} from './referrals/referral-view/referral-view.component';
import {ReferralEditComponent} from './referrals/referral-edit/referral-edit.component';
import {ReordersQueuedComponent} from './reorders/reorders-queued/reorders-queued.component';
import {PendingExtensionsComponent} from './orders/pending-extensions/pending-extensions.component';
import {PendingConversionsComponent} from './orders/pending-conversions/pending-conversions.component';
import {
  OtherTemplatesAddComponent
} from './administration/templates/other-templates/other-templates-add/other-templates-add.component';
import {CardCreationsComponent} from './orders/card-creations/card-creations.component';
import {CardCreationsDetailComponent} from './card-creations/card-creations-detail/card-creations-detail.component';
import {TrustpayUsercheckComponent} from './trustpay-usercheck/trustpay-usercheck.component';
import {CcediComponent} from './ccedi/ccedi.component';
import {MarketingStatisticsComponent} from './marketing-statistics/marketing-statistics.component';
import {MicroPaymentComponent} from './micro-payment/micro-payment.component';
import {
    MicroPaymentSessionDetailComponent
} from './micro-payment/micro-payment-session-detail/micro-payment-session-detail.component';
import {AnnualFeeDeductionsComponent} from './annual-fee-deductions/annual-fee-deductions.component';
import {
    AnnualFeeDeductionDetailComponent
} from './annual-fee-deductions/annual-fee-deduction-detail/annual-fee-deduction-detail.component';
import {GiftCardsComponent} from './giftcards/gift-cards.component';
import {GiftCardBrandsComponent} from './giftcards/gift-card-brands/gift-card-brands.component';
import {GiftCardDetailsComponent} from './giftcards/gift-card-details/gift-card-details.component';
import {GiftCardBrandDetailsComponent} from './giftcards/gift-card-brand-details/gift-card-brand-details.component';
import {FinancialStatisticsComponent} from './financial-statistics/financial-statistics.component';
import {CashbackStatisticsComponent} from './financial-statistics/cashback-statistics/cashback-statistics.component';
import {
  AnnualFeeStatisticsComponent
} from './financial-statistics/annual-fee-statistics/annual-fee-statistics.component';
import {
  TransactionStatisticsComponent
} from './financial-statistics/transaction-statistics/transaction-statistics.component';
import {
  PushNotificationTemplatesEditComponent
} from './administration/templates/push-notification-templates/push-notification-templates-edit/push-notification-templates-edit.component';
import {TplMonthlyReportComponent} from './compliance/tpl-monthly-report/tpl-monthly-report.component';
import {
  WhiteListedSenderAccountsComponent
} from './white-listed-sender-accounts/white-listed-sender-accounts.component';
import {
  WhiteListedSenderAccountDetailComponent
} from './white-listed-sender-accounts/white-listed-sender-account-detail/white-listed-sender-account-detail.component';
import {ImagesComponent} from './administration/images/images.component';
import {ImageDetailComponent} from './administration/images/image-detail/image-detail.component';
import {ImageAlbumComponent} from './administration/images/image-album/image-album.component';
import {AnnualFeesComponent} from "./annual-fees/annual-fees.component";
import {AnnualFeesPaidComponent} from "./annual-fees/annual-fees-paid/annual-fees-paid.component";
import {AnnualFeeDetailComponent} from "./annual-fees/annual-fee-detail/annual-fee-detail.component";
import {AnnualFeeEditComponent} from "./annual-fees/annual-fee-edit/annual-fee-edit.component";
import {GiftCardBrandEditComponent} from "./giftcards/gift-card-brand-edit/gift-card-brand-edit.component";
import {ChargebacksComponent} from "./chargebacks/chargebacks.component";
import {ChargebackDetailComponent} from "./chargebacks/chargeback-detail/chargeback-detail.component";
import {CardActivitiesComponent} from "./card-activities/card-activities.component";
import {CardActivitiesDetailComponent} from "./card-activities/card-activities-detail/card-activities-detail.component";

export const homeRoutes: Routes = [
    {
        path: '', component: HomeComponent, canActivate: [AuthGuard],
        children: [
            { path: '', redirectTo: 'start', pathMatch: 'full' },
            { path: 'start', component: RedirectRoleDeciderComponent },
            {
                path: 'orders',
                children: [
                    { path: '', component: OrdersComponent, canActivate: [ RoleGuard ], data: { roles: [ 'agent', 'partner', 'partner_support' ]}},
                    { path: 'import', component: OrderImportsComponent },
                    { path: 'import/:id', component: OrderImportViewComponent },
                    { path: 'card-creations', component: CardCreationsComponent, canActivate: [RoleGuard], data: { roles: ['admin'] } },
                  { path: 'card-creations/:id', component: CardCreationsDetailComponent, canActivate: [RoleGuard], data: { roles: ['admin'] } },
                    { path: 'card-creation-import', component: CardCreationImportsComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'agent', 'compliance'] } },
                    { path: 'card-creation-import/:id', component: CardCreationImportViewComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'agent', 'compliance'] }  },
                    { path: 'card-activation-import', component: CardActivationImportsComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'agent', 'compliance'] } },
                    { path: 'card-activation-import/:id', component: CardActivationImportViewComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'agent', 'compliance'] } },

                  { path: 'export-all-view', component: OrderExportAllComponent},

                    { path: ':id', component: OrderViewComponent},
                    { path: ':id/edit', component: OrderEditComponent, canActivate: [RoleGuard], data: { roles: ['admin'] } },
                ]
            },

          {
            path: 'annual-fees',
            children: [
              { path: '', component: AnnualFeesComponent, canActivate: [ RoleGuard ], data: { roles: [ 'agent' ]}},
              { path: 'paid', component: AnnualFeesPaidComponent },


              { path: ':id', component: AnnualFeeDetailComponent},
              { path: ':id/edit', component: AnnualFeeEditComponent, canActivate: [RoleGuard], data: { roles: ['admin'] } },
            ]
          },


          {
            path: 'referrals',
            children: [
              { path: '', component: ReferralsComponent, canActivate: [ RoleGuard ], data: { roles: [ 'agent', 'partner', 'partner_support', 'marketing' ]}},

              { path: ':id', component: ReferralViewComponent, canActivate: [ RoleGuard ], data: { roles: [ 'agent', 'partner', 'partner_support', 'marketing' ]}},
              { path: ':id/edit', component: ReferralEditComponent, canActivate: [RoleGuard], data: { roles: ['admin'] } },
            ]
          },

          {
            path: 'gift-cards',
            children: [
              { path: '', component: GiftCardsComponent, canActivate: [ RoleGuard ], data: { roles: [ 'agent', 'partner', 'partner_support', 'marketing' ]}},

              { path: 'brands', component: GiftCardBrandsComponent, canActivate: [ RoleGuard ], data: { roles: [ 'agent', 'partner', 'partner_support', 'marketing' ]}},
              { path: 'brands/:id', component: GiftCardBrandDetailsComponent, canActivate: [ RoleGuard ], data: { roles: [ 'agent', 'partner', 'partner_support', 'marketing' ]}},
              { path: 'brands/:id/edit', component: GiftCardBrandEditComponent, canActivate: [ RoleGuard ], data: { roles: [ 'admin', 'marketing' ]}},
              { path: 'detail/:id', component: GiftCardDetailsComponent, canActivate: [ RoleGuard ], data: { roles: [ 'agent', 'partner', 'partner_support', 'marketing' ]}},
            ]
          },

          {
            path: 'pending-extensions',
            children: [
              { path: '', component: PendingExtensionsComponent, canActivate: [ RoleGuard ], data: { roles: [ 'admin' ]}},
            ]
          },

          {
            path: 'pending-conversions',
            children: [
              { path: '', component: PendingConversionsComponent, canActivate: [ RoleGuard ], data: { roles: [ 'admin' ]}},
            ]
          },


          {
            path: 'orders-cancellations-intern',
            children: [
              { path: '', component: OrdersCancellationsInternComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'agent', 'partner', 'compliance']} },
              { path: ':id', component: OrdersCancellationsInternDetailComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'agent', 'partner', 'compliance']} },
            ]
          },
            {
              path: 'totalcard-orders',
              children: [
                { path: '', component: TotalCardOrdersComponent},
                { path: 'order/:id', component: TotalCardOrderViewComponent},
                { path: 'import-transactions', component: ImportTotalTransactionsComponent },
                { path: 'import-transactions/:id', component: TotalStatsImportViewComponent }

                //{ path: ":id/edit", component: CustomerEditComponent, canActivate: [ RoleGuard ], data: { roles: [ "admin" ] } },
              ]
            },
            {
              path: 'customers-overview',
              children: [
                { path: '', component: CustomersOverviewComponent, canActivate: [ RoleGuard ], data: { roles: [ 'agent', 'partner', 'partner_support', 'issuer_external' ] }},
                { path: ':id', component: CustomerOverviewDetailComponent},
                //{ path: ":id/edit", component: CustomerEditComponent, canActivate: [ RoleGuard ], data: { roles: [ "admin" ] } },
              ]
            },

            {
              path: 'collection-search',
              children: [
                { path: '', component: CollectionSearchComponent},
                { path: ':id', component: CollectionSearchDetailComponent},
                //{ path: ":id/edit", component: CustomerEditComponent, canActivate: [ RoleGuard ], data: { roles: [ "admin" ] } },
              ]
            },

          {
            path: 'idv-customers-overview',
            children: [
              { path: '', component: IdvCustomersOverviewComponent},
              { path: ':id', component: IdvCustomerOverviewDetailComponent},
              //{ path: ":id/edit", component: CustomerEditComponent, canActivate: [ RoleGuard ], data: { roles: [ "admin" ] } },
            ]
          },
          {
            path: 'address-customers-overview',
            children: [
              { path: '', component: AddressCustomersOverviewComponent},
              { path: ':id', component: AddressCustomerOverviewDetailComponent},
              //{ path: ":id/edit", component: CustomerEditComponent, canActivate: [ RoleGuard ], data: { roles: [ "admin" ] } },
            ]
          },

          {
            path: 'chargebacks',
            children: [
              { path: '', component: ChargebacksComponent},
              { path: ':id', component: ChargebackDetailComponent},
            ]
          },

          {
            path: 'ccedi',
            children: [
              { path: '', component: CcediComponent, canActivate: [ RoleGuard ], data: { roles: [ 'super_admin', 'compliance' ] } },
            ]
          },

          {
            path: 'marketing',
            children: [
              { path: 'stats', component: MarketingStatisticsComponent, canActivate: [ RoleGuard ], data: { roles: [ 'super_admin', 'marketing' ] } },
            ]
          },

          {
            path: 'financial',
            children: [
              { path: 'dashboard', component: FinancialStatisticsComponent, canActivate: [ RoleGuard ], data: { roles: [ 'super_admin' ] } },
              { path: 'cashback', component: CashbackStatisticsComponent, canActivate: [ RoleGuard ], data: { roles: [ 'super_admin' ] } },
              { path: 'annual-fee', component: AnnualFeeStatisticsComponent, canActivate: [ RoleGuard ], data: { roles: [ 'super_admin' ] } },
              { path: 'transactions', component: TransactionStatisticsComponent, canActivate: [ RoleGuard ], data: { roles: [ 'super_admin' ] } },
            ]
          },

          {
            path: 'risk',
            children: [
              { path: '', component: RiskComponent, canActivate: [ RoleGuard ], data: { roles: [ 'admin', 'compliance', 'finance_manager', 'issuer_external' ] } },
              { path: 'check', component: RiskCheckComponent, canActivate: [ RoleGuard ], data: { roles: [ 'admin', 'compliance', 'agent', 'manager', 'finance_manager', 'issuer_external' ] } },
              { path: 'check/:id', component: RiskCheckDetailComponent, canActivate: [ RoleGuard ], data: { roles: [ 'admin', 'compliance', 'agent', 'finance_manager', 'issuer_external' ] } },

              { path: 'blocked-cards', component: BlockedCardsComponent, canActivate: [ RoleGuard ], data: { roles: [ 'admin', 'compliance', 'agent', 'manager', 'finance_manager', 'issuer_external' ] } },
              { path: 'dormant-cards', component: DormantCardsComponent, canActivate: [ RoleGuard ], data: { roles: [ 'admin', 'compliance', 'agent', 'manager', 'finance_manager', 'issuer_external' ] } },

              //{ path: ":id", component: AddressCustomerOverviewDetailComponent},
              //{ path: ":id/edit", component: CustomerEditComponent, canActivate: [ RoleGuard ], data: { roles: [ "admin" ] } },
            ]
          },

          {
            path: 'pep',
            children: [
              { path: '', component: PepComponent, canActivate: [ RoleGuard ], data: { roles: [ 'admin', 'compliance', 'manager', 'finance_manager', 'issuer_external' ] } },
              // { path: ":id", component: CustomerViewComponent},
              // { path: ":id/edit", component: CustomerEditComponent, canActivate: [ RoleGuard ], data: { roles: [ "admin" ] } },
            ]
          },

          {
            path: 'reorders',
            children: [
              { path: '', component: ReordersQueuedComponent, canActivate: [ RoleGuard ], data: { roles: [ 'admin', 'compliance', 'manager', 'finance_manager', 'issuer_external' ] } },
              // { path: ":id", component: CustomerViewComponent},
              // { path: ":id/edit", component: CustomerEditComponent, canActivate: [ RoleGuard ], data: { roles: [ "admin" ] } },
            ]
          },

          {
            path: 'send-info',
            children: [
              { path: '', component: SendEmailComponent},
              { path: ':id', component: NewEditSendMailComponent},
              //{ path: ":id/edit", component: CustomerEditComponent, canActivate: [ RoleGuard ], data: { roles: [ "admin" ] } },
            ]
          },

            {
                path: 'customers',
                children: [
                    { path: '', component: CustomersComponent},
                    { path: ':id', component: CustomerViewComponent},
                    { path: ':id/edit', component: CustomerEditComponent, canActivate: [ RoleGuard ], data: { roles: [ 'admin' ] } },
                ]
            },
            {
                path: 'invoices', canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'agent', 'compliance', 'partner'] },
                children: [
                    { path: '', component: InvoicesComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'agent', 'compliance', 'partner']}},
                    { path: ':id', component: InvoiceViewComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'agent', 'compliance', 'partner']}},
                    { path: ':id/edit', component: InvoiceEditComponent, canActivate: [RoleGuard], data: { roles: ['admin'] } },
                ]
            },
            {
                path: 'annual-fee-deductions', canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'agent', 'compliance', 'partner'] },
                children: [
                    { path: '', component: AnnualFeeDeductionsComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'agent', 'compliance', 'partner']}},
                    { path: ':id', component: AnnualFeeDeductionDetailComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'agent', 'compliance', 'partner']}},
                ]
            },
            {
                path: 'companies',
                children: [
                    { path: '', component: CompaniesComponent },
                    { path: 'add', component: CompanyEditComponent, canActivate: [ RoleGuard ], data: { roles: ['admin']} },
                    { path: ':id', component: CompanyViewComponent },
                    { path: ':id/edit', component: CompanyEditComponent, canActivate: [ RoleGuard ], data: { roles: ['admin', 'partner']} },
                ]
            },
            {
              path: 'cards',
              children: [
                  { path: '', component: CardsComponent },
                  { path: 'card-infos', children: [
                    { path: 'next-annual-fees', component: NextAnnualFeesComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'partner'] } },
                    { path: 'next-card-expiries', component: NextCardExpiriesComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'partner'] } },
                    { path: 'last-card-activities', component: LastCardActivitiesComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'partner'] } },
                  ] },
                  { path: 'card-renewal', children: [
                      { path: '', component: CardRenewalComponent, canActivate: [RoleGuard], data: { roles: ['admin'] } },
                      { path: ':id', component: CardRenewalViewComponent },
                      //{ path: ":id/upload-results", component: CompanyEditComponent, canActivate: [ RoleGuard ], data: { roles: ["admin", "partner"]} },
                    ] },
                  //{ path: "card-renewal-import", component: CardRenewalImportComponent, canActivate: [RoleGuard], data: { roles: ["admin"] }  },
                  { path: ':id', component: CardViewComponent },
                  // { path: ":id/edit", component: CardEditComponent, canActivate: [ RoleGuard ], data: { roles: ["admin", "manager", "compliance"]} },
              ]
          },
          {
            path: 'card-activities',
            children: [
              { path: '', component: CardActivitiesComponent },
              { path: ':id', component: CardActivitiesDetailComponent },
            ]
          },
            {
                path: 'payment-import', canActivate: [RoleGuard], data: { roles: 'admin' },
                children: [
                    { path: '', component: PaymentImportComponent },
                    { path: ':id', component: PaymentImportViewComponent },
                ]
            },
          {
            path: 'payment-report', canActivate: [RoleGuard], data: { roles: ['admin', 'partner'] },
            children: [
              { path: '', component: PaymentReportComponent },
            ]
          },

          {
            path: 'loads', canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'compliance', 'partner', 'partner_support', 'wallet', 'issuer_external'] },
            children: [
              { path: '', component: LoadsComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'compliance'] },},
              {
                path: 'sepas', canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'compliance'] },
                children: [
                  { path: '', component: SepasComponent },
                  // { path: "search/:searchquery", component: SepasComponent },
                  // { path: ":id", component: SepaViewComponent },
                  { path: 'import'    , component: SepaImportComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'compliance'] }  },
                  { path: 'import/:id', component: SepaImportViewComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'compliance'] }  },
                ]

              },

              {
                path: 'soforts', canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'compliance']},
                children: [
                  { path: '', component: SofortsComponent },
                  // { path: ":id", component: SofortViewComponent },
                  { path: 'transaction-import'    , component: SofortTransactionImportsComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'compliance'] }  },
                  { path: 'transaction-import/:id', component: SofortTransactionImportViewComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'compliance'] } },
                  { path: 'statement-import'      , component: SofortStatementImportsComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'compliance'] }  },
                  { path: 'statement-import/:id'  , component: SofortStatementImportViewComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'compliance'] }  },
                ]
              },


              {
                path: 'annual-fee', canActivate: [RoleGuard], data: { roles: ['admin', 'compliance'] },
                children: [
                  { path: '', component: RevolutComponent },
                  { path: ':id/:type', component: RevolutDetailsComponent },
                ]

              },

              {
                path: 'needs-check', canActivate: [RoleGuard], data: { roles: ['compliance', 'super_admin'] },
                children: [
                  { path: '', component: TrustpayUsercheckComponent },
                ]

              },

              {
                path: 'btl', canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'compliance', 'finance', 'issuer_external'] },
                children: [
                  { path: '', component: BtlComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'compliance', 'finance'] },},
                  { path: ':id', component: BtlViewComponent },
                  { path: ':id/edit', component: BtlEditComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'compliance', 'finance'] },},
                  { path: 'transaction/:id', component: TransactionViewComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'compliance', 'finance'] },},
                  { path: 'last-load/files', component: LastLoadFilesComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'compliance', 'finance'] },},
                  { path: 'load-refunds/list', component: LoadRefundsComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'compliance', 'finance'] },},
                  { path: 'load-refunds/load-:id', component: LoadRefundsViewComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'compliance', 'finance'] },},
                  { path: 'gps-load-response/upload', component: GpsLoadResponseUploadComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'compliance', 'finance'] },},
                  { path: 'gps-load-response/history', component: GpsHistoryComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'compliance', 'finance'] },},
                  { path: 'load-refunds/history', component: LoadRefundsHistoryComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'compliance', 'finance'] },},

                ]

              },

              {
                  path: 'micropayment', canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'compliance', 'finance'] },
                  children: [
                      { path: '', component: MicroPaymentComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'compliance', 'finance'] },},
                      { path: ':id', component: MicroPaymentSessionDetailComponent },

                  ]

              },

              {
                path: 'white-listed-senders', canActivate: [RoleGuard], data: { roles: ['agent'] },
                children: [
                  { path: '', component: WhiteListedSenderAccountsComponent, canActivate: [RoleGuard], data: { roles: ['agent'] },},
                  { path: ':id', component: WhiteListedSenderAccountDetailComponent },

                ]

              },

              {
                path: 'partner-wallet', canActivate: [RoleGuard], data: { roles: ['admin', 'partner', 'partner_support', 'finance_manager', 'compliance', 'wallet'] },
                children: [
                  { path: '', component: WalletListComponent },
                  { path: ':id', component: WalletViewComponent },
                  { path: ':id/txn/:txnId', component: ViewWalletTransactionComponent },
                  { path: ':id/user/:inviteId', component: WalletUserViewComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'partner', 'finance_manager', 'compliance'] }},
                  /*{ path: ":id/edit", component: BtlEditComponent },*/
                  { path: 'loads-approval', component: LoadsApprovalComponent, canActivate: [RoleGuard], data: { roles: ['admin'] } },
                  { path: 'load-detail/:id', component: LoadDetailComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'partner'] } },
                ]

              },

            ]

          },

          {
            path: 'sof', canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'compliance', 'finance'] },
            children: [
              {
                path: 'btl-detail/:id', component: SofBtlDetailComponent,
              },
              {
                path: 'generic-detail/:id', component: SofGenericDetailComponent,
              },

            ]

          },

          { path: 'partner-wallet-invites', canActivate: [RoleGuard], data: { roles: ['admin', 'compliance'] },
            children: [
              { path: '', component: PendingInvitesComponent },
              { path: ':id', component: PendingInviteDetailComponent }
            ]

          },

          { path: 'compliance', canActivate: [RoleGuard], data: { roles: ['admin', 'compliance'] },
            children: [
              { path: 'tpl_report', component: TplMonthlyReportComponent }
            ]

          },

            {
                path: 'products',
                children: [
                    { path: '', component: ProductsComponent },
                    { path: 'add', component: ProductEditComponent, canActivate: [ RoleGuard ], data: { roles: [ 'admin' ] }},
                    { path: ':id', component: ProductViewComponent },
                    { path: ':id/edit', component: ProductEditComponent, canActivate: [ RoleGuard ], data: { roles: [ 'admin' ] } },
                ]
            },
            {
                path: 'reports', canActivate: [RoleGuard], data: { roles: ['admin', 'manager', 'agent', 'compliance'] },
                children: [
                    { path: '', component: ReportsComponent },
                ]
            },
            {
                path: 'administration', component: AdministrationComponent, canActivate: [RoleGuard], data: { roles:  ['admin', 'marketing', 'compliance'] },
                children: [
                    { path: '', redirectTo: 'reminders', pathMatch: 'full', canActivate: [RoleGuard], data: { roles:  ['admin'] } },
                    { path: 'reminders', children: [
                            { path: '', component: RemindersComponent },
                            { path: ':id', component: ReminderDistributionComponent },
                        ], canActivate: [RoleGuard], data: { roles:  ['admin', 'marketing'] }
                    },
                    { path: '', redirectTo: 'debtors', pathMatch: 'full', canActivate: [RoleGuard], data: { roles:  ['admin'] } },
                    { path: 'debtors', children: [
                            { path: '', component: DebtorsComponent },
                            { path: ':id', component: DebtorDistributionComponent },
                        ]
                    },
                    { path: '', redirectTo: 'fees', pathMatch: 'full', canActivate: [RoleGuard], data: { roles:  ['admin'] } },
                    { path: 'fees', children: [
                            { path: '', component: FeesComponent },
                        ], canActivate: [RoleGuard], data: { roles:  ['admin'] }
                    },
                    {
                        path: 'users',
                        children: [
                            { path: '', component: UsersComponent },
                            { path: ':id', component: UserComponent },
                        ], canActivate: [RoleGuard], data: { roles:  ['admin'] }
                    },
                    { path: 'configs', component: ConfigsComponent },
                    {
                        path: 'templates',
                        children: [
                            { path: '', component: TemplatesComponent },
                            {
                              path: 'push-notification',
                              children: [
                                { path: 'add', component: PushNotificationTemplatesEditComponent },
                                { path: ':id', component: PushNotificationTemplatesEditComponent },
                              ]
                            },
                            {
                                path: 'user-email',
                                children: [
                                    { path: 'add', component: UserEmailTemplatesEditComponent },
                                    { path: ':id', component: UserEmailTemplatesEditComponent },
                                ]
                            },
                          {
                            path: 'order-sms',
                            children: [
                              { path: 'add', component: OrderSmsTemplatesEditComponent },
                              { path: ':id', component: OrderSmsTemplatesEditComponent },
                            ]
                          },
                            {
                                path: 'order-email',
                                children: [
                                    { path: 'add', component: OrderEmailTemplatesEditComponent },
                                    { path: ':id', component: OrderEmailTemplatesEditComponent },
                                ]
                            },
                            {
                              path: 'total-card-order-email',
                              children: [
                                { path: 'add', component: TotalCardEmailTemplatesEditComponent },
                                { path: ':id', component: TotalCardEmailTemplatesEditComponent },
                              ]
                            },
                            {
                              path: 'customer-email',
                              children: [
                                { path: 'add', component: CustomerEmailTemplatesEditComponent },
                                { path: ':id', component: CustomerEmailTemplatesEditComponent },
                              ]
                            },
                            {
                                path: 'invoice-email',
                                children: [
                                    { path: 'add', component: InvoiceEmailTemplatesEditComponent },
                                    { path: ':id', component: InvoiceEmailTemplatesEditComponent },
                                ]
                            },
                            {
                                path: 'invoice-pdf',
                                children: [
                                    { path: 'add', component: InvoicePdfTemplatesEditComponent },
                                    { path: ':id', component: InvoicePdfTemplatesEditComponent },
                                ]
                            },
                            {
                                path: 'others',
                                children: [
                                  { path: 'add', component: OtherTemplatesAddComponent },
                                  { path: ':name', component: OtherTemplatesEditComponent },
                              ]
                          },
                        ]
                    },

                  {
                    path: 'cashback-groups',
                    children: [
                      { path: '', component: CashbackGroupsComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'marketing'] } },
                      { path: ':id', component: CashbackGroupsDetailComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'marketing'] }},
                      { path: ':id/edit', component: CashbackGroupsEditComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'marketing'] } },

                    ]
                  },

                  {
                    path: 'images',
                    children: [
                      { path: '', component: ImagesComponent, canActivate: [RoleGuard], data: { roles: ['admin'] } },
                      { path: ':albumId', component: ImageAlbumComponent, canActivate: [RoleGuard], data: { roles: ['admin'] }},
                      { path: ':albumId/file/:fileName', component: ImageDetailComponent, canActivate: [RoleGuard], data: { roles: ['admin'] }},

                    ]
                  },

                  {
                    path: 'partner-counter',
                    children: [
                      { path: '', component: PartnerCounterIndexComponent, canActivate: [RoleGuard], data: { roles: ['admin'] }},
                      { path: ':companyId', component: PartnerCounterComponent, canActivate: [RoleGuard], data: { roles: ['admin'] }},
                      { path: ':companyId/create-invoice', component: PartnerCounterCreateInvoiceComponent, canActivate: [RoleGuard], data: { roles: ['admin'] }},
                      { path: ':companyId/invoice/:invoiceId', component: PartnerCounterInvoiceDetailComponent, canActivate: [RoleGuard], data: { roles: ['admin'] }},

                    ]
                  },

                ]
            },
            {
                path: 'vouchers',
                children: [
                    { path: '', component: VoucherOrderComponent },
                    { path: 'add', component: VoucherOrderAddComponent, canActivate: [RoleGuard], data: { roles: ['admin', 'partner'] }  },
                    { path: ':id', component: VoucherOrderViewComponent },
                ]
            },
            {
                path: 'my-account',
                children: [
                  { path: '', component: MyAccountComponent },
                  { path: 'change-password', component: ChangePasswordComponent },
                  { path: 'activate-totp', component: ActivateTotpComponent },
                  { path: 'must-activate-mfa', component: MustActivateMfaComponent },
                ]
            },
        ]
    }
];
